import type { ReactNode } from 'react';
import type { T } from '../../i18n';
import type { Nav } from '../../hooks/useHashRoute';
import { CHAPTERS, type ChapterEntry } from '../../chapters/registry';

interface Props {
  chapter: ChapterEntry;
  t: T;
  onNav: Nav;
  children: ReactNode;
}

export function LessonShell({ chapter, t, onNav, children }: Props) {
  const idx = CHAPTERS.findIndex((c) => c.id === chapter.id);
  const prev = idx > 0 ? CHAPTERS[idx - 1] : null;
  const next = idx < CHAPTERS.length - 1 ? CHAPTERS[idx + 1] : null;
  return (
    <div className="lesson">
      {children}
      <div className="lesson-foot">
        {prev ? (
          <a
            className="foot-link"
            data-dir="prev"
            onClick={() => onNav(prev.id)}
            style={{ cursor: 'pointer' }}
          >
            <span className="foot-link-label">
              ← {t('prev')} · §{prev.num}
            </span>
            <span className="foot-link-title">{t(`${prev.id}.title`)}</span>
          </a>
        ) : (
          <span style={{ flex: 1 }} />
        )}
        {next ? (
          <a
            className="foot-link"
            data-dir="next"
            onClick={() => onNav(next.id)}
            style={{ cursor: 'pointer' }}
          >
            <span className="foot-link-label">
              {t('next')} · §{next.num} →
            </span>
            <span className="foot-link-title">{t(`${next.id}.title`)}</span>
          </a>
        ) : (
          <span style={{ flex: 1 }} />
        )}
      </div>
    </div>
  );
}
